import styled from 'styled-components';

export const CBBenefitsStyles = styled.section`
  .benefit-wrap {
    padding: 60px 0;
    border-bottom: 1px solid ${props => props.theme.gray200};
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  }
  .benefit-testimonial-wrap {
    max-width: 600px;
    margin: 30px auto 0;
    ${props => props.theme.media.md} {
      display: flex;
      align-items: center;
      max-width: 600px;
    }
    .benefit-screenshot {
      z-index: 1;
      max-width: 257px;
      height: auto;
      margin: 0 auto;
      display: block;
      display: none;
      ${props => props.theme.media.md} {
        display: block;
      }
    }
    .author-thumb {
      width: 74px;
      height: 74px;
      border-radius: 74px;
    }
  }
  .benefit-testimonial {
    background: ${props => props.theme.gray100};
    padding: 25px;
    margin-left: -2px;
    z-index: 0;
    margin-bottom: 40px;
    &.bt-inverted {
      ${props => props.theme.media.lg} {
        margin-left: 0;
        margin-right: -2px;
      }
    }
    .benefit-quote {
      font-weight: 300;
      font-size: 1.0625rem;
      margin-bottom: 25px;
    }
    .client {
      display: flex;
    }
    .client-info {
      margin-left: 20px;
      .client-name {
        font-size: 0.8125rem;
        font-weight: 700;
        text-transform: uppercase;
      }
      .client-job-title {
        color: ${props => props.theme.gray500};
        font-size: 0.9375rem;
      }
    }
  }
  .benefit-wrap {
    > div {
      display: flex;
      align-items: center;
    }
    .btn {
      margin-top: 15px;
    }
    .no-cc {
      text-align: left;
      font-weight: 300;
      margin: 1em 0 0;
    }
  }
  .benefit {
    max-width: 460px;
    margin: 0 auto;
    .sub-title {
      font-weight: 300;
      margin: -1em 0 1.5em;
    }
  }

  .fancy-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 1.5em;
      background: url('/static/images/icons/check-circle.svg') no-repeat left top 5px;
      background-size: 18px 18px;
      padding-left: 28px;
      line-height: 1.4285;
      font-size: 1.0625rem;
    }
  }
`;
